(function () {
  "use strict";

  if (window.AngelitosHome) {
    window.AngelitosHome.init(document);
    return;
  }

  var instances = new Map();

  function mount(root) {
    if (instances.has(root)) return;

    var sticky = root.querySelector("[data-am-sticky]");
    var heroButton = root.querySelector("[data-am-hero-cta]");
    var products = root.querySelector("[data-am-products]");
    var frame = 0;

    if (!sticky || !heroButton || !products) return;

    function update() {
      frame = 0;

      if (!root.isConnected) return;

      var heroRect = heroButton.getBoundingClientRect();
      var productRect = products.getBoundingClientRect();
      var rootRect = root.getBoundingClientRect();
      var viewportHeight = window.innerHeight;

      var heroPassed = heroRect.bottom < 0;
      var productsVisible =
        productRect.top < viewportHeight &&
        productRect.bottom > 0;

      var footerReached = rootRect.bottom <= viewportHeight;
      var sectionVisible = rootRect.bottom > 0 && rootRect.top < viewportHeight;

      sticky.hidden = !(
        heroPassed &&
        !productsVisible &&
        !footerReached &&
        sectionVisible
      );
    }

    function schedule() {
      if (!frame) {
        frame = window.requestAnimationFrame(update);
      }
    }

    window.addEventListener("scroll", schedule, { passive: true });
    window.addEventListener("resize", schedule);

    var resizeObserver = null;

    if ("ResizeObserver" in window) {
      resizeObserver = new ResizeObserver(schedule);
      resizeObserver.observe(root);
    }

    instances.set(root, function () {
      window.removeEventListener("scroll", schedule);
      window.removeEventListener("resize", schedule);

      if (resizeObserver) resizeObserver.disconnect();
      if (frame) window.cancelAnimationFrame(frame);

      instances.delete(root);
    });

    update();
  }

  function init(scope) {
    if (scope.matches && scope.matches("[data-am-home]")) {
      mount(scope);
    }

    if (scope.querySelectorAll) {
      scope.querySelectorAll("[data-am-home]").forEach(mount);
    }
  }

  window.AngelitosHome = { init: init };

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    Array.from(instances.entries()).forEach(function (entry) {
      var root = entry[0];
      var destroy = entry[1];

      if (event.target === root || event.target.contains(root)) {
        destroy();
      }
    });
  });

  document.addEventListener("shopify:block:select", function (event) {
    var target = event.target;

    if (!target.closest || !target.closest("[data-am-home]")) return;

    var details = target.closest("details");

    if (details) details.open = true;
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
    }, { once: true });
  } else {
    init(document);
  }
})();